(function () {
    'use strict';

    angular
        .module('app')
        .factory('UserPreferenceService', UserPreferenceService);

    function UserPreferenceService($http, $q, $rootScope, WebApiService) {

        var service = {
            getDashboardPreferences: getDashboardPreferences,
            updateDashboardPreferences: updateDashboardPreferences,
            getUserPreferences: getUserPreferences,
            updateUserPreferences: updateUserPreferences,
            updateSingleUserPreference: updateSingleUserPreference,
            deleteUserPreference: deleteUserPreference,
            getUserPreferenceSearch: getUserPreferenceSearch,
            updateUserPreferenceSearch: updateUserPreferenceSearch,
            deleteUserPreferenceSearch: deleteUserPreferenceSearch,
            getFieldConfiguration: getFieldConfiguration,
            updateFieldConfiguration: updateFieldConfiguration,
        };

        return service;

        function getDashboardPreferences() {
            return WebApiService.get('/api/UserPreference/GetDashboardPreferences');
        }

        function getUserPreferences(preferenceName) {
            return WebApiService.get('/api/UserPreference/GetUserPreferences', { PreferenceName: preferenceName });
        }

        function updateDashboardPreferences(dashboardObject) {
            return WebApiService.postJson('/api/UserPreference/UpdateDashboardPreferences', dashboardObject);
        }

        function updateUserPreferences(userPreferencesObject) {
            return WebApiService.postJson('/api/UserPreference/UpdateUserPreferences', userPreferencesObject);
        }

        function deleteUserPreference(userPreferenceId) {
            return WebApiService.postJson('/api/UserPreference/DeleteUserPreference', { UserPreferenceId: userPreferenceId });
        }

        function updateSingleUserPreference(id, name, value, ensureUnique) {

            var postBody = {
                userPreferenceId: id,
                preferenceName: name,
                preferenceValue: value,
                ensureUnique: ensureUnique
            };

            return WebApiService.postJson('/api/UserPreference/UpdateSingleUserPreference', postBody);
        }

        function getUserPreferenceSearch(preferenceId) {
            return WebApiService.get('/api/UserPreference/GetUserPreferenceSearch?SearchType=' + preferenceId);
        }

        function updateUserPreferenceSearch(data) {
            return WebApiService.postJson('/api/UserPreference/UpdateUserPreferenceSearch', data);
        }

        function deleteUserPreferenceSearch(idList) {
            return WebApiService.postJson('/api/UserPreference/DeleteUserPreferenceSearch?idList=' + idList);
        }

        function getFieldConfiguration(userId, moduleId) {
            var data = {
                userId: userId,
                moduleId: moduleId
            }
            return WebApiService.get('/api/UserPreference/fields/getFieldConfiguration/', data);
        }

        function updateFieldConfiguration(data, moduleId) {
            return WebApiService.postJson('/api/UserPreference/fields/updateFieldConfiguration/' + moduleId, data);
        }
    }
})();
